export default {
    'activity': 'activity',
    'select-activity': 'select activity',
    'visit': 'Visit',
    'delete-it': 'delete it',
    'double-visit': 'double visit'
}